/* eslint-disable jira/filename-case */
// We are using a `Symbol` to guarentee the whole object is a particular shape
export const treeItemDataPrivateKey: unique symbol = Symbol('TreeItemData');
